export default __webpack_public_path__ + "static/media/croptop-large-front.9387aca9.jpg";